import type { SelectDropdownOption } from '../../../library/editors/elements/select-dropdown-option';
import { t } from 'src/i18n';

export const specialTermsOptions: SelectDropdownOption[] = [
  { value: 'NONE', text: t('features.specialTermsOptions.selectOrganization') },
  { value: 'DNLF', text: 'Den norske legeforening' },
  { value: 'NTF', text: 'Den norske tannlegeforening' },
  { value: 'NPF', text: 'Norsk psykologforening' },
  { value: 'NFF', text: 'Norsk Fysioterapeutforbund' },
  { value: 'NKF', text: 'Norsk kiropraktorforening' },
  { value: 'NMF', text: 'Norsk manuellterapeutforening' },
  { value: 'NOF', text: 'Norsk osteopatforbund' },
  { value: 'NNF', text: 'Norges Naprapatforbund' },
];
